module.exports = __webpack_public_path__ + "../resources/images/emptyMentions-48905597c2cc89be1efc6460ee080ee6.svg";